"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PortalRegistry = _interopRequireDefault(require("./PortalRegistry"));
/* eslint-disable react/sort-comp */
var PortalProvider = /*#__PURE__*/function (_Component) {
  function PortalProvider() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.portalRegistry = new _PortalRegistry.default();
    return _this;
  }
  (0, _inheritsLoose2.default)(PortalProvider, _Component);
  var _proto = PortalProvider.prototype;
  _proto.getChildContext = function getChildContext() {
    return {
      portalRegistry: this.portalRegistry
    };
  };
  _proto.render = function render() {
    return this.props.children;
  };
  return PortalProvider;
}(_react.Component);
PortalProvider.childContextTypes = {
  portalRegistry: _propTypes.default.instanceOf(_PortalRegistry.default).isRequired
};
PortalProvider.defaultProps = {
  children: undefined
};
var _default = exports.default = PortalProvider;